import React from 'react';
import {Card, CardContent, Typography} from "@material-ui/core";

const AboutUsInfo1 = () => {
  return (
    <Card elevation={4}>
      <CardContent>
        <div>
        <Typography variant="h3" component="span">Our story begins </Typography><Typography variant="body1" component="span">
           in June of 1978. This is when my mother Mary moved to Goshen from
          Saginaw, Michigan in search of work. My great-grandparents lived in Goshen and raved about
          how many factories were in the area and how all of them were hiring. My mother quickly found
          employment, but it was not until 1992 that her cooking journey began to blossom. While
          working for Goshen Rubber she would arise a little bit earlier each morning to make fresh
          breakfast burritos to eat during her break. It was not long before other co-workers noted the
          aroma of her burritos and started to ask where she got them from so, they too could get some.
          When she replied stating that she had made them it was not long until several coworkers were
          requesting burritos. The compliments and positive word to mouth spread like wildfire, this
          caused the requests for burritos and different food items to grow tremendously.
        </Typography>
        </div>
      </CardContent>
    </Card>
  );
};

export default AboutUsInfo1;
